import React from "react";
import { Controller } from "react-hook-form";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Typography,
  Box,
} from "@mui/material";

const CheckboxListFlex = ({
  name,
  control,
  items = [],
  label = "Select Items",
  selectAllLabel = "انتخاب همه",
  direction = "row",
  spacing = 2,
  onChange,
  clearErrors, // <-- pass clearErrors from useForm
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const selectedItems = field.value || [];
        const selectedIdsSet = new Set(selectedItems.map((i) => i.id));

        const allSelected = selectedItems.length === items.length && items.length > 0;
        const someSelected = selectedItems.length > 0 && !allSelected;

        const handleSelectAll = (e) => {
          const updated = e.target.checked ? [...items] : [];
          field.onChange(updated);
          onChange?.(updated);
          clearErrors?.(name); // ✅ safe
        };

        const handleItemChange = (item, checked) => {
          const updated = checked
            ? [...selectedItems.filter((i) => i.id !== item.id), item]
            : selectedItems.filter((i) => i.id !== item.id);

          field.onChange(updated);
          onChange?.(updated);
          clearErrors?.(name); // ✅ safe
        };

        const isChecked = (item) => selectedIdsSet.has(item.id);

        return (
          <Box>
            <Box display="flex" alignItems="center" mb={2}>
              {/* Label */}
              <Typography variant="h6" component="span" mr={2}>
                {label}
              </Typography>

              {/* Error message (smaller font) */}
              {fieldState?.error && (
                <Typography
                  variant="body2"       // smaller than h6
                  component="span"
                  color="error"
                  fontWeight="bold"
                >
                  {fieldState.error.message}
                </Typography>
              )}
            </Box>
            <FormGroup>
              {/* Select All */}
              <FormControlLabel
                control={
                  <Checkbox
                    checked={allSelected}
                    indeterminate={someSelected}
                    onChange={handleSelectAll}
                  />
                }
                label={selectAllLabel}
              />

              {/* Flex container for checkboxes */}
              <Box display="flex" flexDirection={direction} flexWrap="wrap" gap={spacing}>
                {items.map((item) => (
                  <FormControlLabel
                    key={item.id}
                    control={
                      <Checkbox
                        checked={isChecked(item)}
                        onChange={(e) => handleItemChange(item, e.target.checked)}
                      />
                    }
                    label={item.label}
                  />
                ))}
              </Box>
            </FormGroup>


          </Box>
        );
      }}
    />
  );
};

export default CheckboxListFlex;
